import { useTranslation } from 'react-i18next';
import ReactHtmlParser from 'react-html-parser';

const TextosPoliticaPrivacidad = ({ lang, unapolitica }) => {

    const { t } = useTranslation();

    var preidioma = ""
    if (lang != 'es') preidioma = lang + "/";


    return (
        <>
            <section className="u-clearfix u-image u-valign-middle-lg u-valign-middle-sm u-valign-middle-xs u-section-1" id="sec-5458" data-image-width="2132" data-image-height="1420">
                <h1 className="u-align-center u-custom-font u-font-oswald u-text u-text-default u-text-white u-title u-text-1">{t("Politica de privacidad").toUpperCase()}</h1>
            </section>
            <section className="u-clearfix u-section-2" id="block-10">
                <div className="u-clearfix u-sheet u-valign-middle-lg u-valign-middle-sm u-valign-middle-xl u-sheet-1">
                    {ReactHtmlParser(unapolitica.ladesc)}
                </div>
            </section>
        </>
    );
}

export default TextosPoliticaPrivacidad;
